import React from 'react';

export default function PrivacyPolicy() {
  return (
<div className="max-w-xl mx-auto px-4 py-16 sm:px-6 lg:px-8 lg:max-w-7xl">
  <div className="relative">
    <h2 className="text-center text-3xl font-bold tracking-tight font-title">Privacy Policy</h2>
  </div>
  <div className="relative mt-12">
    <div>
      <p>Effective: March 3, 2025</p>

<p>&nbsp;</p>

<p><strong>1. Introduction and Overview.</strong></p>

<p>&nbsp;</p>

<p>
	This Privacy Policy (the “Privacy Policy”) provides a comprehensive description of how LSAT Gains (“We,” “our,” or “us”) collects, uses, and shares
	information about you in connection with your use of the website at
	<a href="http://www.lsatgains.com" target="_blank">www.lsatgains.com</a> (the “Site”), from using our mobile
	application (the “App”) as well as your rights and choices regarding such information. These terms apply
	when you use the Site, the App, and any other online location that links to this Privacy Policy, purchase any
	products or services from us or engage with our content, or otherwise use any of our services (collectively, the
	“Services”).
</p>

<p>&nbsp;</p>

<p>
	By accessing or using the Site or App, you agree to our
	<a href="/terms-of-service" target="_blank">Terms of Service</a>&nbsp;(the “Terms”) and understand that
	the Terms represent a binding agreement between you and us. By using the Services, you also agree to our Personal
	Information collection, use, and disclosure practices, as well as any other activities described in this Privacy
	Policy. If you do not agree with the terms of this Privacy Policy, you should immediately discontinue the use of the
	Services and refrain from accessing the Site or App. If you have any questions or wish to exercise your rights and
	choices, please contact us at the email or postal address set forth in the “Contact Us” section below.
</p>

<p>&nbsp;</p>

<p><strong>2. Changes to Privacy Policy.</strong></p>

<p>&nbsp;</p>

<p>
	This Privacy Policy is effective as of the date at the top of this policy. We reserve the right to revise and
	reissue this Privacy Policy at any time. When we do, we will revise the effective date at the top of this page and
	any changes will be effective immediately upon our posting of the revised Privacy Policy. For the avoidance of
	doubt, your continued use of the Services indicates your consent to the revised Privacy Policy then posted.
</p>

<p>&nbsp;</p>

<p><strong>3. Information Collection.</strong></p>

<p>&nbsp;</p>

<p>
	While using our Services, including when you sign up for an account, we may ask you to provide us with certain
	personally identifiable information that can be used to contact or identify you ("Personal Information").
	We may collect the following categories of Personal Information (a) directly from you, (b) from third parties such
	as social media platforms, (c) from the device and browser that you use to access the Services, and (d) from cookies
	and similar tracking technologies.
</p>

<p>&nbsp;</p>

<p><strong>A. Personal Identifiers</strong></p>

<p>&nbsp;</p>

<p>
	Personal Identifiers may include, but are not limited to your name, phone number, email address, mailing address,
	user ID, passwords, gender, location, birthdate, and any other information you provide to us when you create an
	account, visit or access our Site or Services, or otherwise interact with us.
</p>

<p>&nbsp;</p>

<p><strong>B. Financial and Transactional Information</strong></p>

<p>&nbsp;</p>

<p>
	We may collect payment details (such as credit or debit card information), your billing address, and your order
	history. All payment data is stored by PayPal, Visa, Mastercard or Amex. You may find links to their Privacy
	Policies here:
</p>

<p>&nbsp;</p>

<ul>
<li>
		<a href="https://stripe.com/privacy" target="_blank">Stripe Privacy Statement</a>
	</li>
  <li>
		<a href="https://link.com/privacy" target="_blank">Link Privacy Statement</a>
	</li>
	<li>
		<a href="https://www.paypal.com/us/legalhub/privacy-full#overview" target="_blank">PayPal Privacy Statement</a>
	</li>
	<li>
		<a href="https://usa.visa.com/legal/global-privacy-notice.html" target="_blank">Visa Global Privacy Notice</a>
	</li>
	<li>
		<a href="https://www.mastercard.us/en-us/vision/corp-responsibility/commitment-to-privacy/privacy.html" target="_blank">Mastercard Global Privacy Notice</a>
	</li>
	<li>
		<a href="https://www.americanexpress.com/us/company/privacy-center/online-privacy-disclosures/#privacy-statement" target="_blank">American Express Privacy Statement</a>
	</li>
</ul>

<p>&nbsp;</p>

<p><strong>C. Usage Data</strong></p>

<p>&nbsp;</p>

<p>
	We collect information that your browser sends whenever you
	visit our Site or when you access the Site by or through a mobile device (together, the "Usage Data").
</p>

<p>&nbsp;</p>

<p>
	This Usage Data may also include information such as your computer's Internet Protocol address (e.g., IP
	address), browser type, browser version, the pages of our Services that you visit, the time and date of your visit,
	the time spent on those pages, unique device identifiers and other diagnostic data.
</p>

<p>&nbsp;</p>

<p>
	When you access the Site and Services by or through a mobile device, this Usage Data may include information such as
	the type of mobile device you use, your mobile device unique ID, the IP address of your mobile device, your mobile
	operating system, the type of mobile Internet browser you use, unique device identifiers and other diagnostic data.
</p>

<p>&nbsp;</p>

<p><strong>D. Tracking Data</strong></p>

<p>&nbsp;</p>

<p>
	We use cookies and other tracking technologies to track the activity on our Site and collect certain information
	about your online activity, both on and off our Site. This information may include your browsing history, interests,
	and demographic information.
</p>

<p>&nbsp;</p>

<p>
	Cookies are files with a small amount of data which may include an anonymous unique identifier. Cookies are sent to
	your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and
	scripts to collect and track information and to improve and analyze our Services.
</p>

<p>&nbsp;</p>

<p>
	You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent, typically by
	accessing the “Help,” “Internet Options,” or “Settings” options within your
	browser. However, if you do not accept cookies, you may not be able to use some portions of our Services.
</p>

<p>&nbsp;</p>

<p>Examples of Cookies we use:</p>

<p>&nbsp;</p>

<ul>
	<li>
		<strong>Strictly Necessary Cookies</strong>. These are required for the operation of the Site. These cookies are
		session cookies that are erased when you close your browser.
	</li>
	<li>
		<strong>Preference Cookies</strong>. We use Preference Cookies to remember your preferences and various
		settings.
	</li>
	<li>
		<strong>Analytical/Performance Cookies</strong>. We use these cookies to count the number of visitors to the
		Site and understand how such users navigate through the Site.
	</li>
	<li><strong>Security Cookies</strong>. We use Security Cookies for security purposes.</li>
	<li>
		<strong>Retargeting Cookies</strong>. We use Retargeting Cookies to collect information about your online
		activity, both on and off our Site, and to display targeted ads to you about our products and Services.
	</li>
</ul>

<p>&nbsp;</p>

<p><strong>E. Audio-Visual Information</strong></p>

<p>&nbsp;</p>

<p>
	We may collect your image and voice recordings if you choose to provide such information during your use of the
	Services.
</p>

<p>&nbsp;</p>

<p><strong>F. Social Media Data</strong></p>

<p>&nbsp;</p>

<p>
	Our Services allow you to register an account and log in using your third-party social media credentials (such as
	your Facebook login). If you choose to log in with your social media credentials, we will receive certain profile
	information about you from your social media provider. The profile information we receive may vary depending on the
	social media provider concerned, but will often include your name, email address, friend list, and profile picture,
	as well as other information that you choose to make public on the social media platform. If you log in using
	Facebook, we may also request access to other permissions related to your account, such as your friends, check-ins,
	and likes, and you may choose to grant or deny such requests.
</p>

<p>&nbsp;</p>

<p><strong>G. Geolocation Data</strong></p>

<p>&nbsp;</p>

<p>
	We may collect information about your device’s location, which can either be precise or imprecise. The
	precision of the information that we may collect depends on your device type and the settings that you have
	selected. For example, we may use GPS and other technologies to collect precise geolocation data that tells us your
	device’s exact current location or we may collect geolocation information based on your device’s IP
	address, which gives us general information about the area in which your device is located. You can opt-out of
	allowing us to collect this information either by refusing access to the information or by disabling the location
	settings on your device. Please note that if you choose to opt-out, you may not be able to use certain features of
	the Services.
</p>

<p>&nbsp;</p>

<p><strong>4. Use of Information.</strong></p>

<p>&nbsp;</p>

<p>
	We collect and use Personal Information for Business Purposes (as defined below) in accordance with the practices
	described in this Privacy Policy. “Business Purposes” is defined as any purpose that is necessary or
	reasonably incidental to the operation of the Services, including to provide a personalized experience to you,
	including ads, along with the other purposes explained below:
</p>

<p>&nbsp;</p>

<p>&nbsp;</p>

<p><strong>Provide, personalize, and improve the Services.</strong></p>

<p>
	We use Personal Information to provide and improve our Services. This includes providing the Services to you,
	managing our relationship with you, responding to your inquiries or requests, and requesting your feedback. It also
	includes personalizing features, content and recommendations, as well as to communicate with you using information
	you have given us, like contact information you have entered when signing up for the Services.
</p>

<p>&nbsp;</p>

<p><strong>Protecting the security and integrity of the Service.</strong></p>

<p>
	We use Personal Information to help protect people from harm and provide safe, secure Services by detecting security
	incidents, protecting against malicious, deceptive, fraudulent, or illegal activity, or prosecuting those
	responsible.
</p>

<p>&nbsp;</p>

<p><strong>Sending marketing communications.</strong></p>

<p>
	We may use Personal Information to send you marketing communications about our products and Services, as well as
	those of third parties (as described below). You can opt out of receiving these communications at any time by
	following the “Unsubscribe” link included in our marketing emails or by replying “STOP” to
	any marketing text message we may send to you.
</p>

<p>&nbsp;</p>

<p><strong>Sharing Personal Information with third parties.</strong></p>

<p>
	We may share Personal Information with third parties, such as our marketing partners, analytics providers, and
	payment processors. We also may share Personal Information with social media platforms, such as but not limited to,
	Facebook, YouTube, and Twitter.
</p>

<p>&nbsp;</p>

<p><strong>Complying with legal requirements and enforcing legal terms.</strong></p>

<p>
	We may use Personal Information to fulfill our legal obligations under applicable law, regulation, court order or
	other legal process, to enforce any agreements between LSAT Gains and you, to respond to claims that any posting or
	other content violates third-party rights, and to resolve disputes.
</p>

<p>&nbsp;</p>

<p>
	Notwithstanding the above, we may use information that does not identify you (including Personal Information that
	has been aggregated or de-identified) for any purpose except as prohibited by applicable law. For information on
	your rights and choices with respect to how we use information about you, please see the “Your Rights and
	Choices” section below.
</p>

<p>&nbsp;</p>

<p><strong>5. Sharing and Disclosure of Information.</strong></p>

<p>&nbsp;</p>

<p>
	If we share or disclose Personal Information that we collect, we do so in accordance with the practices described in
	this Privacy Policy. The categories of parties with whom we may share information include:
</p>

<p>&nbsp;</p>

<p>
	<strong>Affiliates</strong>. We may share your personal information with our affiliates, in which case we will
	require those affiliates to honor this Privacy Policy. Affiliates include our parent company and any subsidiaries,
	joint venture partners, or other companies that we control or that are under common control with us.
</p>

<p>&nbsp;</p>

<p>
	<strong>Professional Advisors; Partners</strong>. We may share Personal Information with our professional advisors
	and partners to operate and provide the Services and Site, such as:
</p>

<p>&nbsp;</p>

<ul>
	<li>Professional advisors: who provide us with legal, financial, or other professional services.</li>
	<li>
		Partners: who provide us with services related to the Site and Services, such as payment processing or
		analytics.
	</li>
</ul>

<p>&nbsp;</p>

<p>
	We share Personal Information with these third parties only to the extent necessary to perform their services. We
	may also receive information about your online and offline actions and purchases from Partners who have the rights
	to provide us with your information.
</p>

<p>&nbsp;</p>

<p>
	<strong>Service Providers</strong>. We share Personal Information with third-party service providers for business
	purposes, including fraud detection and prevention, security threat detection, payment processing, customer support,
	data analytics, information technology, storage, and transaction monitoring. Any Personal Information shared with
	such service providers is subject to the terms of this Privacy Policy. All service providers that we engage with are
	restricted to only utilizing the information on our behalf and in accordance with our instructions.
</p>

<p>&nbsp;</p>

<p>
	<strong>Social Media Platforms; Third-party Integrations</strong>. We may share Personal Information with third
	party social media platforms such as, but not limited to, Facebook, Instagram, Twitter, and YouTube, for purposes
	such as targeting ads to you and improving our understanding of your interests. Third party social media platforms
	may also provide us with access to any content that you have provided to and stored in your third-party social media
	account, as well as Personal Information about your interactions with our Services. When you choose to use
	third-party apps, websites, or other services that use, or are integrated with, our Site or Services, they can
	receive information about what you post or share. Information collected by these third-party services is subject to
	their own terms and policies, not this one.
</p>

<p>&nbsp;</p>

<p>
	<strong>Other Users</strong>. When you share personal information or otherwise interact with public areas of the
	Services, such personal information may be viewed by all users and may be publicly made available outside the
	Services in perpetuity. If you interact with other users of our Services or register for our Services through a
	social media platform (such as Facebook), your contact on the social media platform will see your name, profile
	photo, and descriptions of your activity. Similarly, other users will be able to view descriptions of your activity,
	communicate with you within our Services, and view your profile.
</p>

<p>&nbsp;</p>

<p><strong>Third-Party Advertisers</strong>.</p>

<p>
	Our Services may display a third-party hosted “offer wall.” Such an offer wall allows third-party
	advertisers to offer virtual currency, gifts, or other items to users in return for the acceptance and completion of
	an advertisement offer. Such an offer wall may appear in our Services and be displayed to you based on certain data,
	such as your geographic area or demographic information. When you click on an offer wall, you will be brought to an
	external website belonging to third parties and will leave our Services. A unique identifier, such as your user ID,
	will be shared with the offer wall provider in order to prevent fraud and properly credit your account with the
	relevant reward.
</p>

<p>&nbsp;</p>

<p>
	<strong>Merger or Acquisition</strong>. We share Personal Information in connection with, or during negotiations of,
	any proposed or actual merger, purchase, sale or any other type of acquisition or business combination of all or any
	portion of our assets, or transfer of all or a portion of our business to another business.
</p>

<p>&nbsp;</p>

<p>
	<strong>Security and Compelled Disclosure</strong>. We share Personal Information to comply with the law or other
	legal process, and where required, in response to lawful requests by public authorities, including to meet national
	security or law enforcement requirements.
</p>

<p>&nbsp;</p>

<p><strong>Facilitating Requests</strong>. We may share Personal Information about you at your request or direction.</p>

<p>&nbsp;</p>

<p><strong>Consent</strong>. We may share Personal Information about you with your consent.</p>

<p>&nbsp;</p>

<p>
	Notwithstanding the above, we may share Personal Information that does not identify you (including information that
	has been aggregated or de-identified) except as prohibited by applicable law. For information on your rights and
	choices regarding how we share information about you, please see the “Your Rights and Choices” section
	below.
</p>

<p>&nbsp;</p>

<p><strong>6. Other Parties.</strong></p>

<p>&nbsp;</p>

<p>
	We may integrate technologies operated or controlled by other parties into parts of the Services. For example, the
	Services may include links that hyperlink to websites, platforms, and other services not operated or controlled by
	us.
</p>

<p>&nbsp;</p>

<p>
	Please note that when you interact with other parties, including when you leave the Site, those parties may
	independently collect information about you and solicit information from you. We have no control over these linked
	sites, and the information collected and stored by those parties remains subject to their own policies and
	practices, including what information they share with us, your rights and choices on their services and devices, and
	whether they store information in the U.S. or elsewhere. As such we have no responsibility or liability for these
	independent policies or actions and are not responsible for the privacy practices or the content of any such
	websites. We encourage you to familiarize yourself with and consult their privacy policies and terms of use.
</p>

<p>&nbsp;</p>

<p><strong>7. Your Rights and Choices.</strong></p>

<p>&nbsp;</p>

<p>
	<u>Do Not Track</u>. Your browser settings may allow you to automatically transmit a “Do Not Track”
	signal to the online services you visit. Note, however, there is no industry consensus as to what site and app
	operators should do with regard to these signals. Accordingly, unless and until the law is interpreted to require us
	to do so, we do not monitor or take action with respect to “Do Not Track” signals. For more information
	on “Do Not Track,” visit http://www.allaboutdnt.com.
</p>

<p>&nbsp;</p>

<p>
	Please be aware that if you disable or remove tracking technologies some parts of the Services may not function
	correctly.
</p>

<p>&nbsp;</p>

<p>
	<a href="/facebook-data-deletion-instructions-url" target="_blank"><u>Facebook Data Deletion Instructions</u></a>.
</p>

<p>&nbsp;</p>

<p>
	As detailed above, you may choose to log into your LSAT Gains account using your Facebook login credentials. According
	to Facebook policy, we have to provide you with instructions for requesting that we delete your Facebook data.
</p>

<p>&nbsp;</p>

<p>
	If you would like to request deletion of any data that we may have received from your Facebook account, you can
	remove your information by following these instructions:
</p>

<p>&nbsp;</p>

<ul>
	<li>Log in to your Facebook account and go to “Settings &amp; Privacy”.</li>
	<li>Click “Settings”.</li>
	<li>Then click “Security and Login”.</li>
	<li>
		Look for “Apps and Websites” and you will see all of the apps and websites that you have linked with
		your Facebook account.
	</li>
	<li>Locate and click on LSAT Gains in the list of apps and websites.</li>
	<li>Click “Remove” on the pop-up that appears.</li>
</ul>

<p>&nbsp;</p>

<p><u>Updating Your Account Information</u>.</p>

<p>&nbsp;</p>

<p>
	If you would at any time like to review or change the information in your account or terminate your account, you may
	do so by logging in to your account settings and updating your information. Upon your request to terminate your
	account, we will deactivate or delete your account and information from our active databases. However, we may retain
	some of your information in our files to prevent fraud, troubleshoot problems, assist with any investigations,
	enforce our legal terms and/or comply with applicable legal requirements.
</p>

<p>&nbsp;</p>

<ul>
	<li>
		<strong>Please note that this process will require your web developer to make some updates to the website in order
			to automate this process. Facebook has provided the following guidance on this process that you can provide
			to your web developer:
		</strong>
		<a href="https://developers.facebook.com/docs/development/create-an-app/app-dashboard/data-deletion-callback" target="_blank">https://developers.facebook.com/docs/development/create-an-app/app-dashboard/data-deletion-callback</a><strong>.</strong>
	</li>
</ul>

<p>&nbsp;</p>

<p><strong>8. Data Security.</strong></p>

<p>&nbsp;</p>

<p>
	We implement and maintain reasonable administrative, physical, and technical security safeguards to help protect
	information about you from loss, theft, misuse, unauthorized access, disclosure, alteration, and destruction.
	Nevertheless, transmission via the internet is not completely secure and we cannot guarantee the security of
	information about you.
</p>

<p>&nbsp;</p>

<p>
	You play an important role in keeping your information secure. You should not share your username or password with
	anyone. If you have reason to believe that your account is no longer secure, please contact us immediately using the
	contact information in the Contact Us section below.
</p>

<p>&nbsp;</p>

<p><strong>9. International Visitors.</strong></p>

<p>&nbsp;</p>

<p>
	Our Services are hosted in the United States. Our Services are not intended for visitors located in the European
	Economic Area or the United Kingdom and you may not access our Services if you live in or are located in the
	European Economic Area or the United Kingdom.
</p>

<p>&nbsp;</p>

<p><strong>10. Children.</strong></p>

<p>&nbsp;</p>

<p>
	The Services are intended for general audiences and are not directed at children under the age of 18. To use the
	Services, you must be over the age of 18 and legally be able to enter into the Agreement. We do not knowingly
	collect Personal Information (as defined by the U.S. Children’s Online Privacy Protection Act, or
	“COPPA”) from children. If you are a parent or guardian and believe we have collected Personal
	Information in violation of COPPA, please contact us at support@lsatgains.com and we will remove the Personal
	Information in accordance with COPPA.
</p>

<p>&nbsp;</p>

<p><strong>11. Contact Us.</strong></p>

<p>&nbsp;</p>

<p>
	If you have any questions or comments about this Privacy Policy, our data practices, or our compliance with
	applicable law, please contact us:
</p>

<p>&nbsp;</p>

<p>By email: <a href="mailto:contact@lsatgains.com">contact@lsatgains.com</a></p>

<p>&nbsp;</p>

<p>By mail: LSAT Gains. 123 St Miami FL 33304</p>
</div></div></div>
  )
}
